module.exports = __webpack_public_path__ + "static/feature-project-alerts-b85f4cb1f10b6a532049c9554a01cc8a.png";